import React from "react";
export default function TheOpportunity() {
  return <section id="how" className="w-full bg-white px-6 py-24 md:px-16">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <span className="mb-4 inline-block text-xs font-bold uppercase tracking-[0.14em] text-[#028090]">
            How It Works
          </span>

          <h2 className="mb-6 font-serif text-4xl leading-tight text-[#0a2540] md:text-6xl">
            Simple. Smart. Seamless.
          </h2>

          <p className="mx-auto max-w-3xl text-lg leading-8 text-[#4a5f6b]">
            From care gap to confirmed appointment — no portals, no phone calls,
            no friction.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-4">
          <div className="text-center">
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#028090] text-2xl font-bold text-white shadow-lg">
              1
            </div>
            <div className="mb-3 inline-block rounded-full bg-[#e0f5f3] px-3 py-1 text-xs font-bold uppercase tracking-[0.08em] text-[#028090]">
              Automatic
            </div>
            <h4 className="mb-3 font-serif text-xl text-[#0a2540]">
              Care Gap Detected
            </h4>
            <p className="text-sm leading-7 text-[#4a5f6b]">
              KolayHealth identifies overdue preventive care using public
              screening guidelines — not your medical records.
            </p>
          </div>

          <div className="text-center">
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#028090] text-2xl font-bold text-white shadow-lg">
              2
            </div>
            <div className="mb-3 inline-block rounded-full bg-[#e0f5f3] px-3 py-1 text-xs font-bold uppercase tracking-[0.08em] text-[#028090]">
              Smart Match
            </div>
            <h4 className="mb-3 font-serif text-xl text-[#0a2540]">
              Appointment Suggested
            </h4>
            <p className="text-sm leading-7 text-[#4a5f6b]">
              Calendar availability, distance, insurance, and drive time are
              checked before a slot is suggested.
            </p>
          </div>

          <div className="text-center">
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#028090] text-2xl font-bold text-white shadow-lg">
              3
            </div>
            <div className="mb-3 inline-block rounded-full bg-[#e0f5f3] px-3 py-1 text-xs font-bold uppercase tracking-[0.08em] text-[#028090]">
              One Tap
            </div>
            <h4 className="mb-3 font-serif text-xl text-[#0a2540]">
              Patient Books
            </h4>
            <p className="text-sm leading-7 text-[#4a5f6b]">
              No login. No forms. No calls. The slot is reserved and the
              confirmation is sent instantly.
            </p>
          </div>

          <div className="text-center">
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#028090] text-2xl font-bold text-white shadow-lg">
              4
            </div>
            <div className="mb-3 inline-block rounded-full bg-[#e0f5f3] px-3 py-1 text-xs font-bold uppercase tracking-[0.08em] text-[#028090]">
              Real Time
            </div>
            <h4 className="mb-3 font-serif text-xl text-[#0a2540]">
              Everyone Wins
            </h4>
            <p className="text-sm leading-7 text-[#4a5f6b]">
              Patients get the care they need, and providers fill open slots
              while improving preventive care completion.
            </p>
          </div>
        </div>
      </div>
    </section>;
}